import React from "react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { ArrowLeft, PencilSimple, Trash } from "@phosphor-icons/react";
import { ownerDisplayName } from "@/lib/ownerDisplay";

/**
 * Header + KPI cards della pagina PropertyDetail.
 * Componente presentational: riceve i dati e i callback via props.
 */
export default function PropertyHeader({ property, allDocsCount, onEdit, onArchive, onDelete }) {
  const p = property;
  const owner = ownerDisplayName(p);
  return (
    <>
      <Link to="/properties" className="inline-flex items-center gap-2 text-sm text-muted-foreground hover:text-foreground mb-6">
        <ArrowLeft size={16} /> Torna agli immobili
      </Link>
      <div className="mb-8 flex items-start justify-between gap-4 flex-wrap">
        <div>
          {p.is_archived && <div className="label-eyebrow text-amber-700">Archiviato</div>}
          <h1 className="font-display text-4xl font-bold tracking-tight mt-2">
            {owner}
          </h1>
          <p className="text-muted-foreground mt-2">
            {p.address}, {p.city} {p.province && `(${p.province})`} {p.zip_code}
          </p>
          {p.owner_phone && (
            <p className="text-sm text-muted-foreground mt-1">
              📞 {p.owner_phone}{p.owner_email && ` · ${p.owner_email}`}
            </p>
          )}
        </div>
        <div className="flex gap-2 flex-wrap">
          <Button variant="outline" onClick={onEdit} data-testid="edit-property-btn">
            <PencilSimple size={16} className="mr-2" /> Modifica
          </Button>
          {p.is_archived ? (
            <Button
              variant="outline"
              onClick={onArchive}
              className="border-green-300 text-green-700 hover:bg-green-50"
              data-testid="reactivate-property-btn"
            >
              Riattiva immobile
            </Button>
          ) : (
            <Button
              variant="outline"
              onClick={onArchive}
              className="border-amber-300 text-amber-700 hover:bg-amber-50"
              data-testid="archive-property-btn"
            >
              Archivia immobile
            </Button>
          )}
          <div className="hidden sm:block">
            <Button
              variant="outline"
              onClick={onDelete}
              className="border-red-300 text-red-700 hover:bg-red-50"
              data-testid="delete-property-btn"
            >
              <Trash size={16} className="mr-2" /> Elimina
            </Button>
          </div>
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-8">
        <div className="kpi-card">
          <div className="label-eyebrow">{p.owner_type === "azienda" ? "Cliente (azienda)" : "Proprietario"}</div>
          <div className="font-display text-lg font-semibold mt-1">
            {owner}
          </div>
        </div>
        <div className="kpi-card">
          <div className="label-eyebrow">Telefono</div>
          <div className="font-mono text-sm mt-1">{p.owner_phone || "—"}</div>
        </div>
        <div className="kpi-card">
          <div className="label-eyebrow">Documenti totali</div>
          <div className="font-display text-2xl font-bold mt-1">{allDocsCount}</div>
        </div>
      </div>
    </>
  );
}
